import PaymentTerminalContextSelect from "components/data/PaymentTerminalSelect/PaymentTerminalContextSelect";

const TerminalSettings: React.FC = () => <PaymentTerminalContextSelect />;

export default TerminalSettings;
